namespace Matrix.Workflow {
    export interface WorkflowInstanceLogRow {
        LogId?: number;
        WorkflowInstanceId?: number;
        TaskInstanceId?: number;
        LogType?: string;
        LogText?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace WorkflowInstanceLogRow {
        export const idProperty = 'LogId';
        export const nameProperty = 'LogType';
        export const localTextPrefix = 'Workflow.WorkflowInstanceLog';
        export const deletePermission = 'DataAdmin:WorkflowInstanceLog';
        export const insertPermission = 'DataAdmin:WorkflowInstanceLog';
        export const readPermission = 'Read:WorkflowInstanceLog';
        export const updatePermission = 'DataAdmin:WorkflowInstanceLog';

        export declare const enum Fields {
            LogId = "LogId",
            WorkflowInstanceId = "WorkflowInstanceId",
            TaskInstanceId = "TaskInstanceId",
            LogType = "LogType",
            LogText = "LogText",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
